import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> }
const defaultOptions = {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** An ISO formatted date */
  Date: string
  /** The `Upload` scalar type represents a file upload. */
  Upload: string
}

export type Account = {
  __typename?: 'Account'
  id: Scalars['ID']
  name: Scalars['String']
  city: Scalars['String']
  state: Scalars['String']
  latitude?: Maybe<Scalars['String']>
  longitude?: Maybe<Scalars['String']>
  ptdSettings?: Maybe<PtdSettings>
}

export type Analyte = {
  __typename?: 'Analyte'
  name: Scalars['String']
  displayName: Scalars['String']
  defaultUpperLimit?: Maybe<Scalars['Int']>
  defaultLowerLimit?: Maybe<Scalars['Int']>
}

export type Asset = {
  __typename?: 'Asset'
  lastModifiedOn: Scalars['Date']
  serviceLineAsset?: Maybe<ServiceLineAsset>
}

export type AssetClusterResult = {
  __typename?: 'AssetClusterResult'
  clusters: Array<Maybe<AssetMapCluster>>
  points: Array<Maybe<AssetItem>>
}

export type AssetGrid = {
  __typename?: 'AssetGrid'
  items: Array<Maybe<AssetItem>>
  pageNumber: Scalars['Int']
  pageSize: Scalars['Int']
}

/** Enums */
export enum AssetGridSort {
  Address = 'address',
  LastUpdated = 'lastUpdated'
}

export type AssetItem = {
  __typename?: 'AssetItem'
  id: Scalars['ID']
  lastModifiedOn: Scalars['Date']
  location: Location
  serviceLineAsset?: Maybe<ServiceLineAsset>
}

export type AssetMapCluster = Mappable & {
  __typename?: 'AssetMapCluster'
  id: Scalars['ID']
  latitude: Scalars['Float']
  longitude: Scalars['Float']
  leadAssets?: Maybe<Scalars['Int']>
  nonLeadAssets?: Maybe<Scalars['Int']>
  unknownAssets?: Maybe<Scalars['Int']>
  galvanizedAssets?: Maybe<Scalars['Int']>
}

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type Location = {
  __typename?: 'Location'
  id: Scalars['ID']
  addressLine1: Scalars['String']
  addressLine2?: Maybe<Scalars['String']>
  city: Scalars['String']
  state: Scalars['String']
  zip: Scalars['String']
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
}

export type LocationItem = {
  __typename?: 'LocationItem'
  id: Scalars['ID']
  addressLine1: Scalars['String']
  addressLine2?: Maybe<Scalars['String']>
  city: Scalars['String']
  state: Scalars['String']
  zip: Scalars['String']
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  assets: Array<Asset>
}

export type Mappable = {
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
}

export type PtdSettings = {
  __typename?: 'PTDSettings'
  title?: Maybe<Scalars['String']>
  logo?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  sampleExplanation?: Maybe<Scalars['String']>
  hideServiceLines?: Maybe<Scalars['Boolean']>
  systemOwnedName?: Maybe<Scalars['String']>
  customerOwnedName?: Maybe<Scalars['String']>
  consumerConfidenceReportURL?: Maybe<Scalars['String']>
}

export type Point = {
  latitude: Scalars['Float']
  longitude: Scalars['Float']
}

export type Query = {
  __typename?: 'Query'
  /** Fetch a location by it's ID */
  locationDetail?: Maybe<LocationItem>
  /** Fetch an asset by it's ID */
  assetDetail?: Maybe<AssetItem>
  /** Fetch an account by URL slug */
  accountDetail?: Maybe<Account>
  /** Fetch paginated assets for Map */
  assetsGrid: AssetGrid
  /** Fetch asset locations for autocomplete search */
  assetLocationSearch: AssetGrid
  /** Fetch assets for Map with Bounds */
  clustersForBounds: AssetClusterResult
  /** Fetch all service line assets */
  serviceLineAssets?: Maybe<Array<Maybe<AssetItem>>>
}

export type QueryLocationDetailArgs = {
  accountId: Scalars['ID']
  locationId: Scalars['Int']
}

export type QueryAssetDetailArgs = {
  accountId: Scalars['ID']
  assetId: Scalars['Int']
}

export type QueryAccountDetailArgs = {
  accountUrl: Scalars['String']
}

export type QueryAssetsGridArgs = {
  accountId: Scalars['ID']
  pageSize?: Maybe<Scalars['Int']>
  page?: Maybe<Scalars['Int']>
  sort?: Maybe<AssetGridSort>
  direction?: Maybe<SortDirection>
  search?: Maybe<Scalars['String']>
}

export type QueryAssetLocationSearchArgs = {
  accountId: Scalars['ID']
  resultsCount?: Maybe<Scalars['Int']>
  search?: Maybe<Scalars['String']>
}

export type QueryClustersForBoundsArgs = {
  accountId: Scalars['ID']
  boundsBottomLeft: Point
  boundsTopRight: Point
  zoomLevel: Scalars['Int']
}

export type QueryServiceLineAssetsArgs = {
  accountId: Scalars['ID']
}

export type ServiceLineAsset = {
  __typename?: 'ServiceLineAsset'
  status?: Maybe<Scalars['String']>
  privateMaterial?: Maybe<ServiceLineMaterial>
  privateVerifiedDate?: Maybe<Scalars['Date']>
  publicMaterial?: Maybe<ServiceLineMaterial>
  publicVerifiedDate?: Maybe<Scalars['Date']>
}

export type ServiceLineMaterial = {
  __typename?: 'ServiceLineMaterial'
  selectionValue: Scalars['String']
  rawValue: Scalars['String']
  dataCode: Scalars['String']
  epaReportingCategory?: Maybe<Scalars['String']>
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type AccountFragment = { __typename?: 'Account' } & Pick<
  Account,
  'id' | 'name' | 'city' | 'state' | 'latitude' | 'longitude'
> & {
    ptdSettings?: Maybe<{ __typename?: 'PTDSettings' } & PtdSettingsFragment>
  }

export type AnalyteFragment = { __typename?: 'Analyte' } & Pick<
  Analyte,
  'name' | 'displayName' | 'defaultUpperLimit' | 'defaultLowerLimit'
>

export type AssetFragment = { __typename?: 'Asset' } & Pick<
  Asset,
  'lastModifiedOn'
> & {
    serviceLineAsset?: Maybe<
      { __typename?: 'ServiceLineAsset' } & ServiceLineAssetFragment
    >
  }

export type AssetItemFragment = { __typename?: 'AssetItem' } & Pick<
  AssetItem,
  'id' | 'lastModifiedOn'
> & {
    location: { __typename?: 'Location' } & LocationFragment
    serviceLineAsset?: Maybe<
      { __typename?: 'ServiceLineAsset' } & ServiceLineAssetFragment
    >
  }

export type AssetMapClusterFragment = { __typename?: 'AssetMapCluster' } & Pick<
  AssetMapCluster,
  | 'id'
  | 'latitude'
  | 'longitude'
  | 'nonLeadAssets'
  | 'leadAssets'
  | 'unknownAssets'
  | 'galvanizedAssets'
>

export type LocationFragment = { __typename?: 'Location' } & Pick<
  Location,
  | 'id'
  | 'addressLine1'
  | 'addressLine2'
  | 'city'
  | 'state'
  | 'zip'
  | 'latitude'
  | 'longitude'
>

export type LocationItemFragment = { __typename?: 'LocationItem' } & Pick<
  LocationItem,
  | 'id'
  | 'addressLine1'
  | 'addressLine2'
  | 'city'
  | 'state'
  | 'zip'
  | 'latitude'
  | 'longitude'
> & {
    assets: Array<{ __typename?: 'Asset' } & AssetFragment>
  }

export type PtdSettingsFragment = { __typename?: 'PTDSettings' } & Pick<
  PtdSettings,
  | 'title'
  | 'logo'
  | 'description'
  | 'sampleExplanation'
  | 'hideServiceLines'
  | 'systemOwnedName'
  | 'customerOwnedName'
  | 'consumerConfidenceReportURL'
>

export type ServiceLineAssetFragment = {
  __typename?: 'ServiceLineAsset'
} & Pick<
  ServiceLineAsset,
  'status' | 'privateVerifiedDate' | 'publicVerifiedDate'
> & {
    privateMaterial?: Maybe<
      { __typename?: 'ServiceLineMaterial' } & ServiceLineMaterialFragment
    >
    publicMaterial?: Maybe<
      { __typename?: 'ServiceLineMaterial' } & ServiceLineMaterialFragment
    >
  }

export type ServiceLineMaterialFragment = {
  __typename?: 'ServiceLineMaterial'
} & Pick<
  ServiceLineMaterial,
  'selectionValue' | 'rawValue' | 'dataCode' | 'epaReportingCategory'
>

export type AccountDetailsQueryVariables = Exact<{
  accountUrl: Scalars['String']
}>

export type AccountDetailsQuery = { __typename?: 'Query' } & {
  accountDetail?: Maybe<{ __typename?: 'Account' } & AccountFragment>
}

export type AssetDetailQueryVariables = Exact<{
  accountId: Scalars['ID']
  assetId: Scalars['Int']
}>

export type AssetDetailQuery = { __typename?: 'Query' } & {
  assetDetail?: Maybe<{ __typename?: 'AssetItem' } & AssetItemFragment>
}

export type AssetLocationSearchQueryVariables = Exact<{
  accountId: Scalars['ID']
  resultsCount?: Maybe<Scalars['Int']>
  search?: Maybe<Scalars['String']>
}>

export type AssetLocationSearchQuery = { __typename?: 'Query' } & {
  assetLocationSearch: { __typename?: 'AssetGrid' } & Pick<
    AssetGrid,
    'pageNumber' | 'pageSize'
  > & {
      items: Array<
        Maybe<
          { __typename?: 'AssetItem' } & Pick<
            AssetItem,
            'id' | 'lastModifiedOn'
          > & {
              location: { __typename?: 'Location' } & Pick<
                Location,
                | 'addressLine1'
                | 'addressLine2'
                | 'city'
                | 'state'
                | 'zip'
                | 'latitude'
                | 'longitude'
              >
            }
        >
      >
    }
}

export type AssetsGridQueryVariables = Exact<{
  accountId: Scalars['ID']
  search?: Maybe<Scalars['String']>
  page?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
}>

export type AssetsGridQuery = { __typename?: 'Query' } & {
  assetsGrid: { __typename?: 'AssetGrid' } & Pick<
    AssetGrid,
    'pageNumber' | 'pageSize'
  > & { items: Array<Maybe<{ __typename?: 'AssetItem' } & AssetItemFragment>> }
}

export type ClustersForBoundsQueryVariables = Exact<{
  accountId: Scalars['ID']
  boundsBottomLeft: Point
  boundsTopRight: Point
  zoomLevel: Scalars['Int']
}>

export type ClustersForBoundsQuery = { __typename?: 'Query' } & {
  clustersForBounds: { __typename?: 'AssetClusterResult' } & {
    points: Array<Maybe<{ __typename?: 'AssetItem' } & AssetItemFragment>>
    clusters: Array<
      Maybe<{ __typename?: 'AssetMapCluster' } & AssetMapClusterFragment>
    >
  }
}

export type LocationDetailQueryVariables = Exact<{
  accountId: Scalars['ID']
  locationId: Scalars['Int']
}>

export type LocationDetailQuery = { __typename?: 'Query' } & {
  locationDetail?: Maybe<{ __typename?: 'LocationItem' } & LocationItemFragment>
}

export type ServiceLineAssetsQueryVariables = Exact<{
  accountId: Scalars['ID']
}>

export type ServiceLineAssetsQuery = { __typename?: 'Query' } & {
  serviceLineAssets?: Maybe<
    Array<Maybe<{ __typename?: 'AssetItem' } & AssetItemFragment>>
  >
}

export const PtdSettingsFragmentDoc = gql`
  fragment PTDSettings on PTDSettings {
    title
    logo
    description
    sampleExplanation
    hideServiceLines
    systemOwnedName
    customerOwnedName
    consumerConfidenceReportURL
  }
`
export const AccountFragmentDoc = gql`
  fragment Account on Account {
    id
    name
    city
    state
    latitude
    longitude
    ptdSettings {
      ...PTDSettings
    }
  }
  ${PtdSettingsFragmentDoc}
`
export const AnalyteFragmentDoc = gql`
  fragment Analyte on Analyte {
    name
    displayName
    defaultUpperLimit
    defaultLowerLimit
  }
`
export const LocationFragmentDoc = gql`
  fragment Location on Location {
    id
    addressLine1
    addressLine2
    city
    state
    zip
    latitude
    longitude
  }
`

export const ServiceLineMaterialFragmentDoc = gql`
  fragment ServiceLineMaterial on ServiceLineMaterial {
    selectionValue
    rawValue
    dataCode
    epaReportingCategory
  }
`
export const ServiceLineAssetFragmentDoc = gql`
  fragment ServiceLineAsset on ServiceLineAsset {
    status
    privateMaterial {
      ...ServiceLineMaterial
    }
    privateVerifiedDate
    publicMaterial {
      ...ServiceLineMaterial
    }
    publicVerifiedDate
  }
  ${ServiceLineMaterialFragmentDoc}
`
export const AssetItemFragmentDoc = gql`
  fragment AssetItem on AssetItem {
    id
    lastModifiedOn
    location {
      ...Location
    }
    serviceLineAsset {
      ...ServiceLineAsset
    }
  }
  ${LocationFragmentDoc}
  ${ServiceLineAssetFragmentDoc}
`
export const AssetMapClusterFragmentDoc = gql`
  fragment AssetMapCluster on AssetMapCluster {
    id
    latitude
    longitude
    nonLeadAssets
    leadAssets
    unknownAssets
    galvanizedAssets
  }
`
export const AssetFragmentDoc = gql`
  fragment Asset on Asset {
    lastModifiedOn
    serviceLineAsset {
      ...ServiceLineAsset
    }
  }
  ${ServiceLineAssetFragmentDoc}
`
export const LocationItemFragmentDoc = gql`
  fragment LocationItem on LocationItem {
    id
    addressLine1
    addressLine2
    city
    state
    zip
    latitude
    longitude
    assets {
      ...Asset
    }
  }
  ${AssetFragmentDoc}
`
export const AccountDetailsDocument = gql`
  query AccountDetails($accountUrl: String!) {
    accountDetail(accountUrl: $accountUrl) {
      ...Account
    }
  }
  ${AccountFragmentDoc}
`

/**
 * __useAccountDetailsQuery__
 *
 * To run a query within a React component, call `useAccountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDetailsQuery({
 *   variables: {
 *      accountUrl: // value for 'accountUrl'
 *   },
 * });
 */
export function useAccountDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AccountDetailsQuery,
    AccountDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AccountDetailsQuery, AccountDetailsQueryVariables>(
    AccountDetailsDocument,
    options
  )
}
export function useAccountDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountDetailsQuery,
    AccountDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AccountDetailsQuery, AccountDetailsQueryVariables>(
    AccountDetailsDocument,
    options
  )
}
export type AccountDetailsQueryHookResult = ReturnType<
  typeof useAccountDetailsQuery
>
export type AccountDetailsLazyQueryHookResult = ReturnType<
  typeof useAccountDetailsLazyQuery
>
export type AccountDetailsQueryResult = Apollo.QueryResult<
  AccountDetailsQuery,
  AccountDetailsQueryVariables
>
export const AssetDetailDocument = gql`
  query AssetDetail($accountId: ID!, $assetId: Int!) {
    assetDetail(accountId: $accountId, assetId: $assetId) {
      ...AssetItem
    }
  }
  ${AssetItemFragmentDoc}
`

/**
 * __useAssetDetailQuery__
 *
 * To run a query within a React component, call `useAssetDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetDetailQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssetDetailQuery,
    AssetDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AssetDetailQuery, AssetDetailQueryVariables>(
    AssetDetailDocument,
    options
  )
}
export function useAssetDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssetDetailQuery,
    AssetDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AssetDetailQuery, AssetDetailQueryVariables>(
    AssetDetailDocument,
    options
  )
}
export type AssetDetailQueryHookResult = ReturnType<typeof useAssetDetailQuery>
export type AssetDetailLazyQueryHookResult = ReturnType<
  typeof useAssetDetailLazyQuery
>
export type AssetDetailQueryResult = Apollo.QueryResult<
  AssetDetailQuery,
  AssetDetailQueryVariables
>
export const AssetLocationSearchDocument = gql`
  query AssetLocationSearch(
    $accountId: ID!
    $resultsCount: Int
    $search: String
  ) {
    assetLocationSearch(
      accountId: $accountId
      resultsCount: $resultsCount
      search: $search
    ) {
      items {
        id
        lastModifiedOn
        location {
          addressLine1
          addressLine2
          city
          state
          zip
          latitude
          longitude
        }
      }
      pageNumber
      pageSize
    }
  }
`

/**
 * __useAssetLocationSearchQuery__
 *
 * To run a query within a React component, call `useAssetLocationSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetLocationSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetLocationSearchQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      resultsCount: // value for 'resultsCount'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAssetLocationSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssetLocationSearchQuery,
    AssetLocationSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AssetLocationSearchQuery,
    AssetLocationSearchQueryVariables
  >(AssetLocationSearchDocument, options)
}
export function useAssetLocationSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssetLocationSearchQuery,
    AssetLocationSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AssetLocationSearchQuery,
    AssetLocationSearchQueryVariables
  >(AssetLocationSearchDocument, options)
}
export type AssetLocationSearchQueryHookResult = ReturnType<
  typeof useAssetLocationSearchQuery
>
export type AssetLocationSearchLazyQueryHookResult = ReturnType<
  typeof useAssetLocationSearchLazyQuery
>
export type AssetLocationSearchQueryResult = Apollo.QueryResult<
  AssetLocationSearchQuery,
  AssetLocationSearchQueryVariables
>
export const AssetsGridDocument = gql`
  query AssetsGrid(
    $accountId: ID!
    $search: String
    $page: Int
    $pageSize: Int
  ) {
    assetsGrid(
      accountId: $accountId
      search: $search
      page: $page
      pageSize: $pageSize
    ) {
      items {
        ...AssetItem
      }
      pageNumber
      pageSize
    }
  }
  ${AssetItemFragmentDoc}
`

/**
 * __useAssetsGridQuery__
 *
 * To run a query within a React component, call `useAssetsGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetsGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetsGridQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAssetsGridQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssetsGridQuery,
    AssetsGridQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AssetsGridQuery, AssetsGridQueryVariables>(
    AssetsGridDocument,
    options
  )
}
export function useAssetsGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssetsGridQuery,
    AssetsGridQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AssetsGridQuery, AssetsGridQueryVariables>(
    AssetsGridDocument,
    options
  )
}
export type AssetsGridQueryHookResult = ReturnType<typeof useAssetsGridQuery>
export type AssetsGridLazyQueryHookResult = ReturnType<
  typeof useAssetsGridLazyQuery
>
export type AssetsGridQueryResult = Apollo.QueryResult<
  AssetsGridQuery,
  AssetsGridQueryVariables
>
export const ClustersForBoundsDocument = gql`
  query ClustersForBounds(
    $accountId: ID!
    $boundsBottomLeft: Point!
    $boundsTopRight: Point!
    $zoomLevel: Int!
  ) {
    clustersForBounds(
      accountId: $accountId
      boundsBottomLeft: $boundsBottomLeft
      boundsTopRight: $boundsTopRight
      zoomLevel: $zoomLevel
    ) {
      points {
        ...AssetItem
      }
      clusters {
        ...AssetMapCluster
      }
    }
  }
  ${AssetItemFragmentDoc}
  ${AssetMapClusterFragmentDoc}
`

/**
 * __useClustersForBoundsQuery__
 *
 * To run a query within a React component, call `useClustersForBoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClustersForBoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClustersForBoundsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      boundsBottomLeft: // value for 'boundsBottomLeft'
 *      boundsTopRight: // value for 'boundsTopRight'
 *      zoomLevel: // value for 'zoomLevel'
 *   },
 * });
 */
export function useClustersForBoundsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClustersForBoundsQuery,
    ClustersForBoundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ClustersForBoundsQuery,
    ClustersForBoundsQueryVariables
  >(ClustersForBoundsDocument, options)
}
export function useClustersForBoundsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClustersForBoundsQuery,
    ClustersForBoundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ClustersForBoundsQuery,
    ClustersForBoundsQueryVariables
  >(ClustersForBoundsDocument, options)
}
export type ClustersForBoundsQueryHookResult = ReturnType<
  typeof useClustersForBoundsQuery
>
export type ClustersForBoundsLazyQueryHookResult = ReturnType<
  typeof useClustersForBoundsLazyQuery
>
export type ClustersForBoundsQueryResult = Apollo.QueryResult<
  ClustersForBoundsQuery,
  ClustersForBoundsQueryVariables
>
export const LocationDetailDocument = gql`
  query LocationDetail($accountId: ID!, $locationId: Int!) {
    locationDetail(accountId: $accountId, locationId: $locationId) {
      ...LocationItem
    }
  }
  ${LocationItemFragmentDoc}
`

/**
 * __useLocationDetailQuery__
 *
 * To run a query within a React component, call `useLocationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDetailQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useLocationDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    LocationDetailQuery,
    LocationDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LocationDetailQuery, LocationDetailQueryVariables>(
    LocationDetailDocument,
    options
  )
}
export function useLocationDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LocationDetailQuery,
    LocationDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<LocationDetailQuery, LocationDetailQueryVariables>(
    LocationDetailDocument,
    options
  )
}
export type LocationDetailQueryHookResult = ReturnType<
  typeof useLocationDetailQuery
>
export type LocationDetailLazyQueryHookResult = ReturnType<
  typeof useLocationDetailLazyQuery
>
export type LocationDetailQueryResult = Apollo.QueryResult<
  LocationDetailQuery,
  LocationDetailQueryVariables
>
export const ServiceLineAssetsDocument = gql`
  query ServiceLineAssets($accountId: ID!) {
    serviceLineAssets(accountId: $accountId) {
      ...AssetItem
    }
  }
  ${AssetItemFragmentDoc}
`

/**
 * __useServiceLineAssetsQuery__
 *
 * To run a query within a React component, call `useServiceLineAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceLineAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceLineAssetsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useServiceLineAssetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServiceLineAssetsQuery,
    ServiceLineAssetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ServiceLineAssetsQuery,
    ServiceLineAssetsQueryVariables
  >(ServiceLineAssetsDocument, options)
}
export function useServiceLineAssetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServiceLineAssetsQuery,
    ServiceLineAssetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ServiceLineAssetsQuery,
    ServiceLineAssetsQueryVariables
  >(ServiceLineAssetsDocument, options)
}
export type ServiceLineAssetsQueryHookResult = ReturnType<
  typeof useServiceLineAssetsQuery
>
export type ServiceLineAssetsLazyQueryHookResult = ReturnType<
  typeof useServiceLineAssetsLazyQuery
>
export type ServiceLineAssetsQueryResult = Apollo.QueryResult<
  ServiceLineAssetsQuery,
  ServiceLineAssetsQueryVariables
>
